import Divider from "components/BaseWidgets/divider";
import "./style.scss";
import Tag from "components/BaseWidgets/tag";
import { PurpleCircleTick } from "assets/icons";
import { priceFormatPrice } from "utils/formatHelper";

function PlanSummaryCard({ data }) {
  const {
    title = "",
    tagText = "",
    offerPrice = 0,
    oldPrice = 0,
    validity,
    durationText = "",
    features = [],
    price = 0,
    discount_amount = 0,
    planValidity,
  } = data ?? {};

  const finalOldPrice = oldPrice ?? price ?? 0;
  const finalOfferPrice = offerPrice ?? discount_amount ?? 0;
  const plan_validity = validity ?? planValidity ?? 0;

  return (
    <div className="plan-summary-card">
      <div className="header-container flex flex-col gap-2">
        <div className="flex items-center gap-3 justify-between flex-wrap">
          <span className="font-title-lg text-white fw-700 leading-3">
            {title}
          </span>
          <Tag readOnly className="plan-yellow-tag" variant="yellow">
            {tagText}
          </Tag>
        </div>
        <div className="flex gap-3 items-center justify-between flex-wrap">
          <div className="flex items-end gap-1">
            <span className="offer-value">
              {priceFormatPrice(finalOfferPrice, 1)}
            </span>
            <span className="font-body-normal year-text">{durationText}</span>
          </div>
          <p className="text-white font-body-normal">
            Plan validity for
            <span className="text-white ml-1">{plan_validity} days</span>
          </p>
        </div>
        <p className="old-value text-white">
          {priceFormatPrice(finalOldPrice, 1)}
        </p>
      </div>
      <Divider color="#FFFFFF29" />
      <div className="list-container">
        {Array.isArray(features) &&
          features.map((feature, index) => {
            const featureName =
              typeof feature === "string" ? feature : feature?.name;

            return (
              <div
                key={feature.id || index}
                className="flex items-center gap-3"
              >
                <span className="tick-icon">
                  <PurpleCircleTick />
                </span>
                <span className="item-text">{featureName}</span>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default PlanSummaryCard;
